import styled from 'styled-components';
import Button from '../../button';
import { inputStyles } from '../../styled/inputs';
import { breakpoint } from '../../theme/breakpoint';

export const SpacedButton = styled(Button)`
  margin-right: 1em;
`;

export const QuestionBox = styled.div`
  background: ${({ $isAnAnswer, theme }) =>
    ($isAnAnswer && theme.palette.white) ||
    (!$isAnAnswer && theme.palette.grey10)};
  margin-bottom: ${({ theme }) => theme.spacing.standard};
  border: ${({ $isAnAnswer, theme }) =>
    ($isAnAnswer && `1px solid ${theme.palette.grey45}`) ||
    (!$isAnAnswer && 'none')};
`;

export const InputWrap = styled.div`
  display: flex;
  margin-right: 4px;
  margin-bottom: ${({ theme }) => theme.spacing.tiny};

  ${breakpoint.tablet`
    margin-bottom: 0;
  `};
`;

export const SearchInput = styled.input`
  ${inputStyles}
`;

export const Heading = styled.h4`
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey45};
  padding-bottom: ${({ theme }) => theme.spacing.standard};
  margin-top: 0;
`;

export const LookupButton = styled(Button)`
  max-width: 50%;
  ${breakpoint.tablet`
    max-width: auto;
  `};
`;
